<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius pl-20 pr-20 heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col class="heig-frame-child" md="3" @click.stop="clickOutside">
                    <gofix-card title="Equipment Group" class="contractTree contractPropertyAria">
                        <template slot="gofixCard:right_header">
                            <b-button class="mr-3" :disabled ="(isRoot && ClientContractID.status == 'Active') || !$checkRole($accessModule.equipment, 'delete')" @click.stop="modalDeleteEG">
                                <div class="tooltip">Delete</div>
                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                </svg>
                            </b-button>
                            <b-button class="mr-3" :disabled ="!$checkRole($accessModule.equipment, 'create')" @click.stop="modalAddEG">
                                <div class="tooltip">Create</div>
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                </svg>
                            </b-button>
                            <b-dropdown :disabled ="!$checkRole($accessModule.equipment, 'create')" class="btn" right v-b-tooltip.hover title="Setting">
                                <b-dropdown-item @click="modals.importGroup.open = true">Import</b-dropdown-item>
                                <b-dropdown-item @click="modals.importCustomField.open = true">Import Custom fields</b-dropdown-item>
                                <b-dropdown-item href="#">Export action</b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <div class="contenAbsolute">
                            <div class="tree-view-properties">
                                <tree :data="treeData" :options="opts" @node:clicked="selectNodeEG" ref="treeEG" class="content-scroll tree-view-properties">
                                    <div slot-scope="{ node }" class="node-container">
                                        <template>
                                            <i @click.stop="modalEditEG(node)" class="icon-pencil list-eq-icon"></i>
                                        </template>
                                        {{ node.text }}
                                    </div>
                                </tree>
                            </div>
                        </div>
                    </gofix-card>
                </b-col>
                <b-col class="heig-frame-child pl-19" md="9">
                    <custom-field :equipment_group="nodeSelected"></custom-field>
                </b-col>
            </b-row>
        </div>
        <!-- Modal EG: Add/Edit -->
        <b-modal :no-close-on-backdrop="true" id="modal-Equipment" :title="modals.egroup.title" hide-footer :centered="true" v-model="modals.egroup.open">
            <b-form>
                <gofix-form-dropdown
                        label="Node Type"
                        v-if="!isRoot"
                        v-model="modals.egroup.data.type"
                        value="value"
                        vLabel="text"
                        :options="modals.egroup.node_types"
                        :disabled="modals.egroup.disabled_type">
                </gofix-form-dropdown>

                <gofix-form-tree
                        v-if="!isRoot"
                        label="Parent"
                        :options="modals.egroup.parents"
                        :load-options="loadOptionPR"
                        placeholder=""
                        v-model="modals.egroup.data.parent"
                        :normalizer="normalizer"
                        search-nested
                        valueFormat="object">
                </gofix-form-tree>

                <gofix-form-input label="Name" v-model="modals.egroup.data.name" required></gofix-form-input>

                <gofix-form-tree
                        v-if="!isRoot"
                        label="Category"
                        :default-expand-level="1"
                        :options="modals.egroup.services"
                        :load-options="loadOptionSC"
                        placeholder=""
                        v-model="modals.egroup.data.service"
                        :normalizer="normalizer"
                        search-nested
                        valueFormat="object">
                </gofix-form-tree>

                <gofix-form-tree
                        v-if="!isRoot"
                        label="Master"
                        :default-expand-level="1"
                        :options="modals.egroup.masterEG"
                        :load-options="loadOptionMaster"
                        placeholder=""
                        v-model="modals.egroup.data.master_reference"
                        :normalizer="normalizer"
                        search-nested
                        valueFormat="object">
                </gofix-form-tree>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveEG" :loading="modals.loading.eg" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Modal EG: Delete -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.delete.open">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteEG">Yes</b-button>
            </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="true"
                 @hide="modals.importCustomField.data.file = null"
                 title="import file"
                 ref="modal-import-customfield"
                 modal-class="modal-Import"
                 id="modal-import-customfield"
                 v-model="modals.importCustomField.open"
                 hide-footer>
            <b-form>
                <b-form-group>
                    <b-form-file ref="file-input-structure-custom-field" accept=".csv" v-model="modals.importCustomField.data.file" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="uploadFileImportCustomfields" :loading="modals.importCustomField.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 @hide="modals.importGroup.data.file = null"
                 title="import file"
                 ref="modal-import-customfield"
                 modal-class="modal-Import"
                 id="modal-import-customfield"
                 v-model="modals.importGroup.open"
                 hide-footer>
            <b-form>
                <b-form-group>
                    <b-form-file ref="file-input-structure-custom-field" accept=".csv" v-model="modals.importGroup.data.file" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="uploadFileImportGroup" :loading="modals.importGroup.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import LiquorTree from 'liquor-tree';
    import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
    import customField from "./equipment-group-custom-field";
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    export default {
        name: 'equipment-group',
        components: {
            [LiquorTree.name]: LiquorTree,
            customField
        },
        data() {
            return {
                /* --- Tree --- */
                treeData: this.getTreeEG(),
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false
                        if(node.data.id == this.rootID) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
                                id: node.id,
                                contract_id: this.$route.params.id
                            })
                            .then(response => {
                                if (response.data.status == 200) {
                                    response.data.data.map(item => {
                                        item.data.master = item.master;
                                        item.data.service_category = item.service_category;
                                        return item;
                                    })
                                    resolve(response.data.data)
                                }

                            })
                            .catch(error => reject(error));
                        });
                    }
                },
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value && value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                nodeSelected: null,
                rootID: 0,
                isRoot: false,
                modals: {
                    egroup: {
                        title: 'Add Equipment Type',
                        open: false,
                        disabled_type: false,
                        parents:  [],
                        services: [],
                        masterEG: [],
                        node_types: [
                            {
                                value: 'equipment_category',
                                text: 'Equipment Category'
                            }, 
                            {
                                value: 'equipment_type',
                                text: 'Equipment Type'
                            }
                        ],
                        data: {
                            id: 0,
                            parent_id: 1,
                            node_type: 'equipment_category',
                            name: '',
                            service_category_id: null,
                            type: {
                                value: 'equipment_category',
                                text: 'Equipment Category'
                            }, 
                            parent: null,
                            service: null,
                            master_reference: null
                        }
                    },
                    delete: {
                        open: false
                    },
                    loading: {
                        eg: false
                    },
                    timer: {
                        saveEG: null
                    },
                    importGroup:{
                        open: false,
                        loading: false,
                        data:{
                            contract_id: this.$route.params.id,
                            file: null,
                            is_master: false
                        }
                    },
                    importCustomField:{
                        open: false,
                        loading: false,
                        data:{
                            contract_id: this.$route.params.id,
                            file: null
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        watch: {
            ClientContractID: async function(val, old) {
                if (val && old && val.id != old.id) {
                    this.getSC();
                    let result = await this.getTreeEG()
                    if(result) {
                        this.$refs.treeEG.tree.setModel(result);
                    }
                }
            },
        },
        mounted() {
            this.$refs.treeEG.$on('tree:mounted', (data) => {
                this.modals.egroup.parents = JSON.parse(JSON.stringify(this.$refs.treeEG.toJSON(), this.replace));
            })
            this.$refs.treeEG.$on('tree:data:received', (data) => {
                this.modals.egroup.parents = JSON.parse(JSON.stringify(this.$refs.treeEG.toJSON(), this.replace));
            })
            this.$refs.treeEG.$on('node:selected', (data) => {
                this.modals.egroup.parents = JSON.parse(JSON.stringify(this.$refs.treeEG.toJSON(), this.replace));
            })
        },
        async created() {
            this.getSC();
            this.getMasterEG();
        },
        methods: {
            clickOutside() {
                /*unset select node tree*/
                let node = this.$refs.treeEG.selected()
                node.unselect()

                this.nodeSelected = null
                this.modals.egroup.data = Object.assign(this.modals.egroup.data, {
                    id: 0,
                    parent_id: 1,
                    node_type: 'equipment_category',
                    name: '',
                    service_category_id: null,
                    type: {
                        value: 'equipment_category',
                        text: 'Equipment Category'
                    }, 
                    parent: this.nodeSelected ? this.nodeSelected : null,
                    service: null,
                    master_reference: null
                });
            },

            modalAddEG() {
                this.isRoot = false;
                this.modals.egroup.data = Object.assign(this.modals.egroup.data, {
                    id: 0,
                    parent_id: 1,
                    node_type: 'equipment_category',
                    name: '',
                    service_category_id: null,
                    type: {
                        value: 'equipment_category',
                        text: 'Equipment Category'
                    }, 
                    parent: this.nodeSelected ? this.nodeSelected : null,
                    service: null,
                    master_reference: null
                });
                
                this.refreshModalEG(1, '');
            },

            modalEditEG(node) {
                this.nodeSelected = node;
                this.nodeSelected.parent_id_old = node.data.parent_id 
                this.isRoot = (this.rootID == node.data.id) ? true : false;
                this.modals.egroup.disabled_type = (node.data.isBatch && node.data.isBatch === true) ? true : false;

                /* Find node Parent */
                let nodeParent = this.$refs.treeEG.find({
                    data: {
                        id: node.data.parent_id
                    }
                });
                this.modals.egroup.data = Object.assign(this.modals.egroup.data, {
                    id: node.data.id,
                    node_type: node.data.node_type,
                    name: node.data.name,
                    parent_id: node.data.parent_id,
                    service_category_id: node.data.service_category_id,
                    parent: (nodeParent && nodeParent[0]) ? nodeParent[0].toJSON() : null,
                    service: node.data.service_category,
                    master_reference: node.data.master,
                    type: {
                        value: node.data.node_type,
                        text: node.data.node_type == 'equipment_category' ? 'Equipment Category' : 'Equipment Type'
                    }
                })
                this.refreshModalEG(1, '', 'Edit', 'update');
            },

            refreshModalEG(is_turn = 1, keyMsg = 'adding', method = 'Add', role_method = 'create') {
                this.modals.egroup.parents = JSON.parse(JSON.stringify(this.$refs.treeEG.toJSON(), this.replace));
                if(is_turn) {
                    if(!this.$checkRole(this.$accessModule.equipment, role_method)) return;
                    this.modals.egroup.title = `${method} Equipment Type`;
                    this.modals.egroup.open = true;
                } else {
                    this.modals.egroup.open = false;
                    this.$bvToast.toast(this.$notificationV2(keyMsg, 'equipment_structure'), {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'success',
                        solid: true
                    });
                }
            },

            saveEG() {
                if (this.modals.timer.saveEG) {
                    clearTimeout(this.modals.timer.saveEG);
                    this.modals.timer.saveEG = null;
                }
                this.modals.timer.saveEG = setTimeout(() => {
                    if (!this.modals.egroup.data.type && !this.isRoot)
                        return this.$bvToast.toast('Please select node type', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    if (!this.modals.egroup.data.name.trim())
                        return this.$bvToast.toast('Name is a required field.', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    if (!this.modals.egroup.data.parent && !this.isRoot)
                        return this.$bvToast.toast('Please select parent', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    if (!this.isRoot)
                        if ((this.modals.egroup.data.parent.data.node_type == 'equipment_type' && this.modals.egroup.data.type.value == 'equipment_type') || (this.modals.egroup.data.parent.data.node_type == 'Root' && this.modals.egroup.data.type.value == 'equipment_type') || this.modals.egroup.data.parent.data.node_type == 'equipment_type') {
                            return this.$bvToast.toast('Please select again', {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'danger',
                                solid: true
                            })
                        }
                    if (this.modals.egroup.data.parent && this.modals.egroup.data.id == this.modals.egroup.data.parent.data.id)
                        return this.$bvToast.toast('Please select again', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })

                    this.modals.loading.eg = true;
                    let keyMsg = 'adding';
                    let method = 'CreateEquipmentStructure';
                    if (this.modals.egroup.data.id != 0) {
                        keyMsg = 'editing';
                        method = 'UpdateEquipmentStructure';
                    }
                    let request = Object.assign({}, {
                        id:   this.modals.egroup.data.id,
                        name: this.modals.egroup.data.name.trim(),
                        node_type: (!this.isRoot) ? this.modals.egroup.data.type.value : 'Root',
                        parent_id: (!this.isRoot) ? this.modals.egroup.data.parent.data.id : null,
                        master_reference:    this.modals.egroup.data.master_reference ? this.modals.egroup.data.master_reference.id : null,
                        service_category_id: this.modals.egroup.data.service ? this.modals.egroup.data.service.id : null
                    })
                    this.$store.dispatch(`EquipmentV2Controller/${method}`, request)
                    .then(response => {
                        this.modals.loading.eg = false;
                        if (response.data.status == 200) {
                            if (!request.id) {
                                /* Find node parent*/
                                let nodeParent = this.$refs.treeEG.find({
                                    data: {
                                        id: response.data.data.parent_id
                                    }
                                })

                                if (nodeParent && nodeParent[0]) {
                                    nodeParent[0].data.isBatch = true;
                                    let newNode = nodeParent[0].append({
                                        id: response.data.data.id,
                                        text: response.data.data.name,
                                        data: {
                                            isBatch:               false,
                                            id:        response.data.data.id,
                                            text:      response.data.data.name,
                                            name:      response.data.data.name,
                                            node_type: response.data.data.node_type,
                                            parent_id: response.data.data.parent_id,
                                            master:    response.data.data.master,
                                            master:    response.data.data.master,
                                            service_category:    response.data.data.service_category,
                                            service_category_id: response.data.data.service_category_id,
                                           
                                        }
                                    });

                                    nodeParent[0].expand();
                                    newNode.expand();
                                }
                            } else {
                                /* Case: Node is Root */
                                if (this.isRoot) {
                                    this.nodeSelected.text = request.name;
                                    this.nodeSelected.data.name = request.name;
                                } else {
                                    let node = this.$refs.treeEG.selected()
                                    node.unselect();
                                    if (this.nodeSelected.parent_id_old && (this.nodeSelected.parent_id_old != request.parent_id)) {
                                        this.$refs.treeEG.remove(this.nodeSelected)
                                        let nodeParent = this.$refs.treeEG.find({
                                            data: {
                                                id: request.parent_id
                                            }
                                        })

                                        if (nodeParent && nodeParent[0]) {
                                            if(nodeParent[0].isBatch == false || request.parent_id == this.rootID) {
                                                let newNode = nodeParent[0].append(this.nodeSelected)
                                                newNode.selected();
                                                
                                            }
                                            nodeParent[0].expand();
                                        }
                                    } else {
                                        this.nodeSelected.data = Object.assign(this.nodeSelected.data, {
                                            text:      request.name,
                                            name:      request.name,
                                            node_type: request.node_type,
                                            parent_id: request.parent_id,
                                            master:    this.modals.egroup.data.master_reference,
                                            service_category:    this.modals.egroup.data.service,
                                            service_category_id: request.service_category_id
                                        });

                                        /* Find node*/
                                        let node = this.$refs.treeEG.find({
                                            data: {
                                                id: request.id
                                            }
                                        })

                                        if(node && this.nodeSelected != null) {
                                            this.nodeSelected = node[0]
                                            node[0].selected();
                                        }
                                    }
                                }
                            }
                            this.refreshModalEG(0, keyMsg);
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        this.modals.loading.eg = false;
                    })
                }, 100)
            },

            modalDeleteEG() {
                if(!this.$checkRole(this.$accessModule.equipment, 'delete')) return;
                if (this.nodeSelected == null) {
                    return this.$bvToast.toast('Please select equipment type before deleting!', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'warning',
                        solid: true
                    });
                }
                this.modals.delete.open = true;
            },

            deleteEG() {
                this.nodeSelected.contract_id = this.$route.params.id;
                this.$store.dispatch('EquipmentV2Controller/DeleteEquipmentStructure', this.nodeSelected)
                .then(response => {
                    if (response.data.status == 200) {
                        if (this.nodeSelected.data.id == this.rootID) {
                            this.nodeSelected.children = [];
                            this.$refs.treeEG.tree.find({state: {selected: true}}).unselect();
                        } else {
                            this.$refs.treeEG.remove(this.nodeSelected)
                        }

                        this.nodeSelected = null;
                        this.modals.delete.open = false;
                        this.modals.egroup.parents = JSON.parse(JSON.stringify(this.$refs.treeEG.toJSON(), this.replace));
                        this.$bvToast.toast(this.$notificationV2('deleting', 'equipment_structure'), {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                    }
                })
            },

            /* --- Tree --- */
            async getTreeEG() {
                let response = await this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
                    id: 0,
                    contract_id: this.$route.params.id
                })
                if (response.data.status == 200) {
                    
                    if(response.data.data[0]) {
                        this.rootID = response.data.data[0].id;
                        response.data.data[0].children.map(item => {
                            item.data.master = item.master;
                            item.data.service_category = item.service_category;
                            return item;
                        })
                    }
                    return response.data.data
                }
                return []
            },
            selectNodeEG(node) {
                if(node) {
                    this.nodeSelected = node;
                    this.isRoot = (this.rootID == node.data.id) ? true : false;
                }
            },

            /* Tree select */
            normalizer(node) {
                if (node.data.isBatch)
                    return {
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    }
                return {
                    id: node.data.id,
                    label: node.text,
                    children: undefined
                }
            },
            loadOptionPR( { action, parentNode, callback } ) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return
                    };
                    if (parentNode.data.isBatch) {
                        this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
                            id: parentNode.data.id,
                            contract_id: this.$route.params.id
                        })
                            .then(result => {
                                simulateAsyncOperation(() => {
                                    parentNode.children = result.data.data;
                                    callback();
                                })
                            })
                    } else {
                        parentNode.children = []
                        callback();
                    }
                }
            },
            loadOptionSC( { action, parentNode, callback } ) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return
                    };
                    if (parentNode.data.isBatch) {
                        this.$store.dispatch("ServiveCategoryController/getServiceCategories", { contractId: this.$route.params.id, categoryId: parentNode.data.id})
                            .then(result => {
                                simulateAsyncOperation(() => {
                                    parentNode.children = result;
                                    callback();
                                })
                            })
                    }
                    else {
                        parentNode.children = []
                        callback();
                    }
                }
            },
            loadOptionMaster( { action, parentNode, callback } ) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return
                    };
                    if (parentNode.data.isBatch) {
                        this.$store.dispatch("EquipmentStructureMasterController/getEquipmentCategory", {
                            id: parentNode.data.id,
                        })
                            .then(result => {
                                simulateAsyncOperation(() => {
                                    parentNode.children = result.data.data;
                                    callback();
                                })
                            })
                    } else {
                        parentNode.children = []
                        callback();
                    }
                }
            },

            getSC() {
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', { contractId: this.$route.params.id, categoryId: 0 })
                .then(result => {
                    this.modals.egroup.services = result;
                })
                .catch(error => {
                    this.modals.egroup.services = [];
                })
            },

            getMasterEG() {
                this.$store.dispatch("EquipmentStructureMasterController/getEquipmentCategory", {id: 0})
                .then(response => {
                    this.modals.egroup.masterEG = response.data.data;
                })
                .catch(err => {
                    this.modals.egroup.masterEG = [];
                })
            },
            async uploadFileImportCustomfields() {
                if (!this.modals.importCustomField.data.file) {
                    return this.$bvToast.toast("Please choose file to import", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.modals.importCustomField.loading = true;
                this.$store.dispatch(`EquipmentStructureController/importCustomFields`, this.modals.importCustomField.data)
                    .then(async response => {
                        this.modals.importCustomField.loading = false;
                        this.modals.importCustomField.open = false;
                        this.nodeSelected = null;
                        let treeData = await this.getTreeEG()
                        if(treeData) this.$refs.treeEG.tree.setModel(treeData);
                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'equipment_group_custom_field');
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }
                        return this.$bvToast.toast( msg, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: variant,
                            solid: true
                        })
                    })
                    .catch(err => {
                        this.modals.importCustomField.loading = false;
                        let msg = "Can't import data!";
                        if( err.response.data.error 
                            && err.response.data.error.message
                        ) {
                            msg = err.response.data.error.message;
                        }

                        return this.$bvToast.toast(msg, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    })
            },
            uploadFileImportGroup(){
                if (!this.modals.importGroup.data.file) {
                    return this.$bvToast.toast("Please choose file to import", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.modals.importGroup.loading = true;
                this.$store.dispatch(`EquipmentStructureController/uploadFileImport`, this.modals.importGroup.data)
                    .then(async response => {
                        this.modals.importGroup.loading = false;
                        this.modals.importGroup.open = false;
                        this.tree = this.getTreeEG();
                        let treeData = await this.getTreeEG()
                        if(treeData) this.$refs.treeEG.tree.setModel(treeData);

                        let variant = 'success';
                        let msg = this.$notificationV2('importing', 'equipment_structure');
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }
                        return this.$bvToast.toast( msg, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: variant,
                            solid: true
                        })
                    })
                    .catch(err => {
                        this.modals.importGroup.loading = false;
                        let msg = "Can't import data!";
                        if( err.response.data.error 
                            && err.response.data.error.message
                        ) {
                            msg = err.response.data.error.message;
                        }
                        return this.$bvToast.toast( msg, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    })
            }
        }
    }
</script>
